<template>
  <el-form-item :label="form.cname+':'"
    :key="form.key"
    :prop="prop"
    :rules="rule">
    <el-input v-if="status === 'edit'"
      readonly
      v-model="form.fieldValue">
      <el-button slot="append"
        icon="el-icon-search"
        @click="findCode"></el-button>
    </el-input>
    <span v-else>{{form.fieldValue || '&nbsp;' }}</span>
    <code-select-modal ref="modal"
      :callback="callback" />
  </el-form-item>
</template>
<script>
import CodeSelectModal from './busi/code-select-modal.vue'
export default {
  name: 'form-code',
  components: { CodeSelectModal },
  props: {
    item: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    },
    prop: {
      type: String,
      required: true
    },
    status: {
      type: String,
      default: 'edit'
    },
    cb: Function
  },
  computed: {
    form: {
      get () {
        return this.item
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    rule () {
      return {
        required: this.form.mandatory,
        message: this.form.cname + '不能为空',
        trigger: 'blur'
      }
    }
  },
  methods: {
    callback (v) {
      this.form.fieldValue = v.hsCode
      this.cb && this.cb(v)
    },
    findCode () {
      console.log('findCode')
      this.$refs.modal.fetch()
    }
  }
}
</script>
